const DEFAULT_PROFILE_PHOTOS = [
  require('../../assets/profile_photos/koi.png'),
  require('../../assets/profile_photos/bear.png'),
  require('../../assets/profile_photos/ostrich.png'),
  require('../../assets/profile_photos/panda-bear.png'),
  require('../../assets/profile_photos/shark.png'),
];

export function isValidPhotoURL(value) {
  return (
    typeof value === 'string' &&
    value.trim().length > 0 &&
    (value.startsWith('http://') || value.startsWith('https://'))
  );
}

export function getDefaultProfilePhoto(userKey) {
  const key = String(userKey || 'default');
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash + key.charCodeAt(i)) | 0;
  }
  return DEFAULT_PROFILE_PHOTOS[Math.abs(hash) % DEFAULT_PROFILE_PHOTOS.length];
}

export function getUserPhotoSource(user, useFallback = false) {
  if (isValidPhotoURL(user?.photoURL)) {
    return { uri: user.photoURL.trim() };
  }
  if (useFallback) {
    return getDefaultProfilePhoto(user?.id || user?.uid || user?.email);
  }
  return null;
}
